import { getTranslate } from '@/helpers/translateHelpers';
import { ECurrencies, ELanguages, TDropDownItemWithType } from '@/types';

export const LANGUAGE_NAME = 'tffLang';

export const currencyList = (): Array<TDropDownItemWithType<string>> => [
  {
    label: getTranslate('universal.rub'),
    value: ECurrencies.rub,
  },
];

export const languageList = (): Array<TDropDownItemWithType<string>> => [
  {
    label: getTranslate('universal.ru'),
    value: ELanguages.ru,
  },
];
